export default ({
  orderRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const order = await orderRepository.fetchOrder({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({ order})
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
